import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Invitation from "@/pages/Invitation";
import Forgot from "@/pages/Forgot";
import Reset from "@/pages/Reset";
import Inicio from "@/pages/firm/Inicio";
import MisAsuntos from "@/pages/firm/MisAsuntos";
import NuevoAnalisis from "@/pages/firm/NuevoAnalisis";
import AsuntoDetalle from "@/pages/firm/AsuntoDetalle";
import Seguridad from "@/pages/firm/Seguridad";
import Ajustes from "@/pages/firm/Ajustes";
import Acuerdo from "@/pages/firm/Acuerdo";
import Cuenta from "@/pages/firm/Cuenta";
import Solicitudes from "@/pages/admin/Solicitudes";
import AdminAsuntos from "@/pages/admin/AdminAsuntos";
import AdminAsuntoDetalle from "@/pages/admin/AdminAsuntoDetalle";
import Despachos from "@/pages/admin/Despachos";
import AvisoLegal from "@/pages/legal/AvisoLegal";
import PoliticaPrivacidad from "@/pages/legal/PoliticaPrivacidad";
import PoliticaCookies from "@/pages/legal/PoliticaCookies";

function Loader() {
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--ivory)" }}>
      <div className="ddp-brand" style={{ fontSize: 40, opacity: .5 }}>DDP</div>
    </div>
  );
}

function Protected({ children, role, requireAgreement = false }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (user === false) {
    if (typeof window !== "undefined") {
      const dest = window.location.pathname + window.location.search;
      if (!dest.startsWith("/acceso")) sessionStorage.setItem("ddp_redirect", dest);
    }
    return <Navigate to="/acceso" replace />;
  }
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin/asuntos" : "/inicio"} replace />;
  }
  if (requireAgreement && user.role === "firm_user" && user.agreement_accepted === false) {
    return <Navigate to="/acuerdo" replace />;
  }
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/acceso" element={<Login />} />
      <Route path="/invitacion/:token" element={<Invitation />} />
      <Route path="/recuperar" element={<Forgot />} />
      <Route path="/restablecer/:token" element={<Reset />} />

      {/* Legal (public) */}
      <Route path="/aviso-legal" element={<AvisoLegal />} />
      <Route path="/privacidad" element={<PoliticaPrivacidad />} />
      <Route path="/cookies" element={<PoliticaCookies />} />

      {/* Firm */}
      <Route path="/inicio" element={<Protected role="firm_user"><Inicio /></Protected>} />
      <Route path="/nuevo-analisis" element={<Protected role="firm_user" requireAgreement><NuevoAnalisis /></Protected>} />
      <Route path="/asuntos" element={<Protected role="firm_user" requireAgreement><MisAsuntos /></Protected>} />
      <Route path="/asuntos/:id" element={<Protected role="firm_user" requireAgreement><AsuntoDetalle /></Protected>} />
      <Route path="/ajustes" element={<Protected role="firm_user"><Ajustes /></Protected>} />
      <Route path="/acuerdo" element={<Protected role="firm_user"><Acuerdo /></Protected>} />
      <Route path="/cuenta" element={<Protected role="firm_user"><Cuenta /></Protected>} />
      <Route path="/seguridad" element={<Protected><Seguridad /></Protected>} />

      {/* Admin */}
      <Route path="/admin/solicitudes" element={<Protected role="admin"><Solicitudes /></Protected>} />
      <Route path="/admin/asuntos" element={<Protected role="admin"><AdminAsuntos /></Protected>} />
      <Route path="/admin/asuntos/:id" element={<Protected role="admin"><AdminAsuntoDetalle /></Protected>} />
      <Route path="/admin/despachos" element={<Protected role="admin"><Despachos /></Protected>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors closeButton />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
